import { mapState } from 'vuex';
import Card from './card/Card.vue';

const cols = (options, n) => options && options.columns && options.columns === n;

export default {
  name: 'Deck',
  components: {
    Card
  },
  computed: {
    cols3() {
      return cols(this.options, 3);
    },
    cols4() {
      return cols(this.options, 4);
    },
    cols5() {
      return cols(this.options, 5);
    },
    font() {
      return this.options && this.options.font ? this.options.font : 'Palatino, Times, serif';
    },
    ...mapState([
      'options'
    ])
  },
  props: {
    cards: {
      type: Array,
      required: true
    }
  }
};
